import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadSiteConfig } from './config/site';
import './styles/variables.css';
import './styles/global.css';
import './styles/typography.css';
import './styles/layout.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const render = () => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
};

// SITE (business name, address, support contact) needs to be filled in before anything renders —
// a plain object mutated after a page has already mounted doesn't cause React to re-render, so
// someone landing straight on /terms or /privacy would otherwise see it empty. loadSiteConfig()
// already swallows its own errors; the timeout here only guards against a slow network hanging
// the whole app over a details fetch that isn't essential to using the product.
const timeout = new Promise((resolve) => setTimeout(resolve, 1500));
Promise.race([loadSiteConfig(), timeout]).then(render);
